/* REACT */
import React, { useMemo } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'
import queryString from 'query-string'

/* COMPONENTS */
import { Image } from '../../../../components/ui'

/* STORE */

/* STYLES */
import {
  SearchBoxWrapper,
  SearchWrapper,
  SearchIconWrapper,
  SearchIconImage,
  SubmitIconWrapper,
  SearchOuterWrapper,
  SearchRecommendationsBullet,
  SearchRecommendationsConatiner,
  SelectedTripContainer,
  SelectedTripContainerBullet,
  SelectedTripContainerBulletText,
  SearchFiltersConatiner,
  SearchFiltersBullet,
} from './style'

/* UTILS/CONSTANTS/IMAGES-ASSETS */
import { CLOUDFRONT_BASE_URL } from '../../../../utils/constants'
import { getTranslations } from '../../../../utils'

const SearchBox = ({
  language,
  isLessThanLaptop,
  onSearchSubmit,
  quickSearches,
  handleQuickSearch,
  defaultSearchResults,
  searchQuery,
  handleSearchQueryChange,
  organizationSlug,
  selectedTripType,
  removeSelectedTripType = () => {},
  filters,
}) => {
  const SubmitText = `${CLOUDFRONT_BASE_URL}/assets/${organizationSlug}/images/MayaSendTextButton.png`
  const SearchIcon = `${CLOUDFRONT_BASE_URL}/assets/common/images/SearchIcon.png`
  const CloseIcon = `${CLOUDFRONT_BASE_URL}/assets/${organizationSlug}/icons/Close.svg`

  const handleClick = e => {
    e.preventDefault()
    if (!searchQuery) return // If user hasn't typed anything, don't send search request

    onSearchSubmit(searchQuery)
  }

  const handleKeyPress = e => {
    if (e.keyCode === 13 && !e.shiftKey) handleClick(e)
  }

  const defaultSearchQueries = useMemo(() => {
    if (!quickSearches) return []

    let defaultSearchQueries = []

    if (quickSearches?.generic) {
      defaultSearchQueries = quickSearches.generic
    }

    const { query } = queryString.parseUrl(window.location.search)

    if (query?.m_tt) {
      let tripType = query.m_tt
      if (quickSearches[tripType]) {
        defaultSearchQueries = quickSearches[tripType]
      }
    }

    return defaultSearchQueries
  }, [quickSearches])

  return (
    <SearchOuterWrapper>
      <SearchBoxWrapper>
        <SearchIconWrapper>
          <SearchIconImage
            src={SearchIcon}
            alt='Search Icon'
            width={'25px'}
            height={'25px'}
            minWidth={'25px'}
            minHeight={'25px'}
            onClick={handleClick}
          />
        </SearchIconWrapper>

        <SearchWrapper
          type='text'
          placeholder={getTranslations('search_placeholder')}
          value={searchQuery}
          onKeyDown={handleKeyPress}
          onChange={e => handleSearchQueryChange(e.target.value)}
        ></SearchWrapper>

        <SubmitIconWrapper>
          <SearchIconImage
            src={SubmitText}
            alt='Search Submit'
            width={'30px'}
            height={'30px'}
            minWidth={'30px'}
            minHeight={'30px'}
            onClick={handleClick}
          />
        </SubmitIconWrapper>
      </SearchBoxWrapper>
      {selectedTripType ? (
        <SelectedTripContainer>
          <SelectedTripContainerBullet key={selectedTripType || ``}>
            <SelectedTripContainerBulletText>
              {selectedTripType}
            </SelectedTripContainerBulletText>
            <Image
              src={CloseIcon}
              width={'10px'}
              height={'10px'}
              onClick={e => {
                removeSelectedTripType()
              }}
            />
          </SelectedTripContainerBullet>
        </SelectedTripContainer>
      ) : null}
      {filters && filters.length ? (
        <SearchFiltersConatiner>
          {filters?.map(filter => (
            <SearchFiltersBullet key={filter?.title || ``}>
              {filter?.title}: {filter?.value || ``}
            </SearchFiltersBullet>
          ))}
        </SearchFiltersConatiner>
      ) : null}

      {defaultSearchResults ? (
        <SearchRecommendationsConatiner>
          {defaultSearchQueries &&
            defaultSearchQueries?.map(reply => (
              <SearchRecommendationsBullet
                key={reply?.content || ``}
                onClick={e => {
                  handleQuickSearch(reply?.content || ``)
                }}
              >
                {reply?.content || ``}
              </SearchRecommendationsBullet>
            ))}
        </SearchRecommendationsConatiner>
      ) : null}
    </SearchOuterWrapper>
  )
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(SearchBox)
